import React, {Fragment, useEffect, useState} from "react";
import {Alert, Box, Grid, MenuItem, Select, Snackbar,} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {makeStyles} from "@mui/styles";

import {getMinimalPlayers} from "../../redux/actions/player-area-action/scores-action";
import {addSmpPlayersInMatch} from "../../redux/actions/smp-action/create-smp-action";
import {getLatestLeagueSMP} from "../../redux/actions/smp-action/smp-league-list";
import {LoadingButton} from "@mui/lab";
import {useNavigate} from "react-router-dom";
import BoxNumber from "./Components/BoxNumber";
import {toast} from "react-toastify";

const useStyles = makeStyles({
    numberBox: {
        backgroundColor: "#000",
        color: "#fff",
        padding: "8px",
        width: 30,
        minWidth: 30,
        borderRadius: "8px 0px 0px 8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "12px",
        fontWeight: 700,
    },
    selectBox: {
        width: "100%",
        // maxWidth: "130px",
        borderTop: "1px solid rgba(0, 0, 0, 0.42)",
        borderRight: "1px solid rgba(0, 0, 0, 0.42)",
        borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
        borderRadius: "0px 8px 8px 0px",
        paddingLeft: 4,
        fontSize: "4px",
    },
    mainSelectionBox: {
        display: "flex",
        height: "45px",
        marginBottom: 3,
        position: "relative",
    },
});

const CreateSMP = ({setToggleUpdateSMP}) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const createSmpList = useSelector((state) => state?.createSmpListReducer);
    // const leagueSMP = useSelector((state) => state.smpLeagueReducer);
    const selectedSmpSelector = useSelector(
        (state) => state.getSelectedLeagueReducer
    );
    const playersList = useSelector(
        (state) => state?.getMinimalPlayerReducer?.data
    );

    const noOfPlayers =
        selectedSmpSelector?.status?.leageData[0]?.season_description
            ?.no_of_players;
    const leagueId = selectedSmpSelector?.status?.leageData[0]?._id;
    const roundId = selectedSmpSelector?.status?.leageData[0]?.rounds[0]?._id;

    const [allPlayersList, setAllPlayersList] = useState(playersList);
    const [newTempPlayers, setNewTempPlayers] = useState([]);
    const [hasApiMatches, setHasApiMatches] = useState(false);
    const [showError, setShowError] = useState(false);
    const [groups, setGroups] = useState([]);

    // Create Empty player list initially with groups defined
    const createEmptyPlayerList = () => {
        let obj = {};
        let players = [];

        for (let i = 0; i < noOfPlayers / 2; i++) {
            if (i % 2 == 0) {
                obj["group1"] = null;
                players.push(obj);
            } else {
                obj["group2"] = null;
                players.push(obj);
                obj = {};
            }
        }

        setGroups(players);
    };

    const handleSelectedPlayer = (
        currentValue,
        groupIndex,
        groupNumber,
        mathcIndex
    ) => {
        let _newPlayers = [];
        const playerIndex =
            mathcIndex % 2 == 0 ? (groupIndex + 1) * 2 - 1 : (groupIndex + 1) * 2;

        setNewTempPlayers((prev) => {
            const isExist = prev.find((elm) => elm.playerIndex === playerIndex);
            if (isExist) {
                _newPlayers = prev.map((pl) => {
                    if (pl.playerIndex === playerIndex) {
                        return {...pl, _id: currentValue};
                    } else {
                        return {...pl};
                    }
                });
            } else {
                _newPlayers = [...prev, {playerIndex, _id: currentValue}];
            }

            return _newPlayers;
        });

        setGroups((prev) => {
            const newPlayer = {user_id: currentValue};
            return prev.map((pl, idx) => {
                if (currentValue == "bye") {
                    if (idx == groupIndex) return {...pl, [groupNumber]: []};
                } else {
                    const {is_bye, ...rest} = pl;
                    if (idx == groupIndex) return {...rest, [groupNumber]: [newPlayer]};
                }
                return pl;
            });
        });
    };

    const onSubmit = () => {
        const refactoredGroups = groups.map((group) => {
            if (group.group1 != null && group.group2 != null) {
                if (group.group1.length == 0 && group.group2.length == 0) {
                    return null;
                } else {
                    if (group.group1.length == 0) {
                        return {...group, is_bye: "group1"};
                    } else if (group.group2.length == 0) {
                        return {...group, is_bye: "group2"};
                    } else return {...group};
                }
            } else return {...group};
        });

        const hasUndefined = refactoredGroups.filter((x) => x == undefined);

        if (hasUndefined.includes(undefined)) {
            toast.error("You can't have 2 players as 'BYE' in a same group");
        } else {
            let newMatches;
            if (hasApiMatches) {
                newMatches = {
                    league_id: leagueId,
                    matches: [...refactoredGroups],
                    round_id: roundId,
                };
            } else {
                newMatches = {league_id: leagueId, matches: [...refactoredGroups]};
            }

            dispatch(addSmpPlayersInMatch(newMatches));
        }
    };

    useEffect(() => {
        if (
            createSmpList?.loading === false &&
            createSmpList?.status?.error === false
        ) {
            setNewTempPlayers([]);
            setToggleUpdateSMP(false);
            setShowError(null);
        }

        if (createSmpList?.status) {
            setShowError(true);
        }
    }, [createSmpList]);

    useEffect(() => {
        setAllPlayersList(playersList);
    }, [playersList]);

    useEffect(() => {
        dispatch(getLatestLeagueSMP());
        dispatch(getMinimalPlayers());

        if (selectedSmpSelector?.status?.leageData[0].rounds.length > 0) {
            setHasApiMatches(true);
            setGroups([
                ...selectedSmpSelector?.status?.leageData[0].rounds[0]?.matches,
            ]);
            // Push players in new temp player list
            let _temp = [];
            [...selectedSmpSelector?.status?.leageData[0].rounds[0]?.matches].map(
                (group, idx) => {
                    Object.entries(group)
                        .slice(0, 2)
                        .map(([_, value], index) => {
                            if (value != null) {
                                const playerIndex =
                                    index % 2 == 0 ? (idx + 1) * 2 - 1 : (idx + 1) * 2;
                                const newTempPl = {playerIndex, _id: value[0]?.user_id};
                                _temp.push(newTempPl);
                            }
                        });
                }
            );
            setNewTempPlayers(_temp);
        } else {
            createEmptyPlayerList();
            setNewTempPlayers([]);
            setHasApiMatches(false);
        }
    }, []);

    const handleClose = () => setShowError(false);

    return (
        <Fragment>
            <Box sx={{mt: 4}}>
                {groups?.map((item, idx) => {
                    return Object.entries(item)
                        .slice(0, 2)
                        .map(([key, value], index) => {
                            return (
                                <Grid container spacing={2} key={index}>
                                    <Grid item xs={3} xl={2}>
                                        <Box
                                            sx={{mb: `${index % 2 == 1 ? "20px" : "5px"}`}}
                                            className={classes.mainSelectionBox}
                                        >
                                            <BoxNumber childIndex={index} parentIndex={idx}/>

                                            <Select
                                                variant="standard"
                                                sx={{
                                                    "::before": {display: "none"},
                                                    ":focus-within": {outline: "none"},
                                                    ":focus": {outline: "none"},
                                                }}
                                                value={
                                                    value == null
                                                        ? null
                                                        : value[0]?.name == "BYE" || value.length == 0
                                                            ? "bye"
                                                            : value[0]?.user_id
                                                }
                                                className={classes.selectBox}
                                                onChange={(e) =>
                                                    handleSelectedPlayer(e.target.value, idx, key, index)
                                                }
                                            >
                                                <MenuItem value="bye">Bye</MenuItem>
                                                {allPlayersList?.map((item) => (
                                                    <MenuItem
                                                        key={item._id}
                                                        value={item._id}
                                                        sx={{
                                                            display:
                                                                newTempPlayers
                                                                    .map((e) => {
                                                                        return e._id;
                                                                    })
                                                                    .indexOf(item._id) !== -1 && "none",
                                                        }}
                                                    >
                                                        {item.first_name} {item.last_name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Box>
                                    </Grid>
                                </Grid>
                            );
                        });
                })}
            </Box>

            <Snackbar
                anchorOrigin={{vertical: "top", horizontal: "center"}}
                open={showError}
                autoHideDuration={3000}
                onClose={handleClose}
            >
                <Alert onClose={handleClose} severity="error">
                    {createSmpList?.status}
                </Alert>
            </Snackbar>

            <Grid container spacing={2}>
                <Grid item xs={2}>
                    <LoadingButton
                        loading={createSmpList?.loading}
                        fullWidth
                        onClick={onSubmit}
                        className={classes.saveBtn}
                        sx={{
                            my: 2,
                            backgroundColor: "#06623B",
                            color: "#fff",
                            ":hover": {backgroundColor: "#06623B"},
                            ":disabled": {opacity: 0.6},
                        }}
                        disabled={newTempPlayers.length < 1 || createSmpList?.loading}
                    >
                        Save
                    </LoadingButton>
                </Grid>
            </Grid>
        </Fragment>
    );
};

export default CreateSMP;
